import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { Image } from '@chakra-ui/react'
import { ContainerImage } from './styles'
import { useState } from 'react'

export function SlideImages({ images }) {
  const [copy, setCopy] = useState(false)

  function copyToClipboard() {
    navigator.clipboard.writeText(images[0].url)
    setCopy(true)
  }

  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={3}
      onSlideChange={() => console.log('slide change')}
      onSwiper={(swiper) => console.log(swiper)}
    >
      {images?.map((item, index) => (
        <SwiperSlide key={index}>
          <ContainerImage onClick={() => copyToClipboard()}>
            <Image src={item.url} alt="imagem" />
          </ContainerImage>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
